import { MaybePromise } from "@homebound/activesupport";
import { Button, Css, GridTableApi, IconButton, useComputed } from "@homebound/beam";

export type CollapseRowToggleProps = {
  rowId: string;
  label: string;
  api: GridTableApi<any>;
  compact?: boolean;
  onCollapse?: () => MaybePromise<void>; // Optional callback when the row is collapsed
};

/** Wraps `CollapseToggle` and adds a button label. */
export function CollapseRowToggle({ api, rowId, label, onCollapse, compact = false }: CollapseRowToggleProps) {
  const isCollapsed = useComputed(() => api.isCollapsedRow(rowId), [api]);
  const iconKey = isCollapsed ? "chevronRight" : "chevronDown";
  const toggleCollapsedRow = async () => {
    api.toggleCollapsedRow(rowId);
    isCollapsed && (await onCollapse?.());
  };
  return (
    <div css={Css.df.jcc.$}>
      <Button variant="text" label={label} onClick={toggleCollapsedRow} />
      <IconButton onClick={toggleCollapsedRow} icon={iconKey} compact={compact} />
    </div>
  );
}
